import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Stack,
  Text,
  Progress,
  Button,
  Flex,
} from "@chakra-ui/react";
import { UploadProgressState } from "../hooks/useUploader";

interface FileUploadProgressModalProps {
  isOpen: boolean;
  onClose: () => void;
  uploadState: UploadProgressState | null;
}

const FileUploadProgressModal: React.FC<FileUploadProgressModalProps> = (
  props
) => {
  const { uploadState, onClose } = props;
  const [allDone, setAllDone] = useState(false);
  const uploadStates = uploadState ? Object.values(uploadState) : [];

  useEffect(() => {
    if (
      uploadStates.length &&
      uploadStates.every((state) => {
        return state.done;
      })
    ) {
      setAllDone(true);
    }
  }, [uploadState]);

  const renderFileProgressIndicators = () => {
    if (!uploadState) return null;

    const indicators = [];
    for (const state of uploadStates) {
      indicators.push(
        <Stack key={state.name}>
          <Text>{state.name}</Text>
          <Progress
            value={state.progress}
            colorScheme={state.error ? "red" : state.done ? "green" : "blue"}
          />
        </Stack>
      );
    }
    return (
      <Stack spacing={4} mb={5}>
        {indicators}
      </Stack>
    );
  };

  return (
    <Modal
      isCentered
      isOpen={props.isOpen}
      onClose={() => null}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent maxW={1000} mr={5} ml={5}>
        <ModalHeader>Upload Progress</ModalHeader>
        <ModalBody>
          <Stack mb={4}>
            {renderFileProgressIndicators()}
            <Flex justifyContent="flex-end">
              <Button
                isFullWidth={false}
                isLoading={!allDone}
                colorScheme="gray"
                loadingText="Uploading"
                onClick={onClose}
              >
                Finished
              </Button>
            </Flex>
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default FileUploadProgressModal;
